import quotes from "../../apis/quotes";
export default {
  add_quotes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await quotes.add_quotes(payload);
        // commit("CREATE_DOCTOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_quotes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await quotes.get_quotes(payload);
        // console.log(data.data.data.data, "data651");
        commit("GET_QUOTE", data.data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_quotes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await quotes.delete_quotes(payload);
        // commit("DELETE_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  update_quotes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await quotes.update_quotes(payload);
        // commit("EDIT_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
